module.exports = __webpack_public_path__ + "img/letras.1481d714.png";